/**
 * JOB Value Not String
 */
export default ['configJobList', 'scheduleFrequency', 'jobNames', 'index', 'type', 'scheduleType'];
